import './MapList.scss';
import { Api } from '@services';
import { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Text } from '../../../components';
import {
  Icon,
  LinkCellRenderer,
  MapThumbnailCellRenderer,
  V2EditCellRenderer,
} from '../../../components';
import { PagedQueryParams, ServerSideGrid } from '../../../components/grids/AgGrid/ServerSideGrid';
import { PagedModel } from '../../../models/PagedModel';
import { mapListV2ColumnDefs } from './columnDefs';
import { isReadOnly, isUser } from '../../../utils';

export function MapList() {
  const [showGrid, setShowGrid] = useState<boolean>(true);
  const [hasAnyMaps, setHasAnyMaps] = useState<boolean>(true);
  const [rowData, setRowData] = useState<any>(new PagedModel());
  const [csvData, setCsvData] = useState<any>(new PagedModel());
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDeleteSuccess = () => {
    // Update the rowData count by decrementing it by 1
    setRowData((prevRowData) => {
      const newCount = prevRowData.count - 1;
      return { ...prevRowData, count: newCount };
    });
  };

  const FetchData = async (payload: any, isCSV: any, queryState: any) => {
    setIsLoading(true);
    Api.get(
      `v2/maps?pageSize=${queryState.pageSize}&page=${queryState.pageNumber}&search=${
        queryState.filter
      }&orderBy=${queryState.orderBy()}`,
    ).then((results: any) => {
      if (results.data.count === 0) {
        if (queryState.filter) {
          setShowGrid(true); // still show the grid (empty)
          setRowData(results.data);
        } else {
          setHasAnyMaps(false);
          setShowGrid(false);
        }
      } else {
        setHasAnyMaps(true);
        setShowGrid(true);
        if (isCSV) {
          setCsvData(results.data);
        } else {
          setRowData(results.data);
        }
      }
      setIsLoading(false);
    });
  };

  return (
    <>
      {showGrid ? (
        <ServerSideGrid
          id={'MapList'}
          columnDefs={mapListV2ColumnDefs(handleDeleteSuccess)}
          handleFetchData={FetchData}
          rowData={rowData}
          csvData={csvData}
          isLoading={isLoading}
          disabledFilters={[]}
          filterControl={false}
          searchControl={true}
          viewingControl={true}
          pagerControl={true}
          exportControl={false}
          gridProps={{
            frameworkComponents: {
              V2EditCellRenderer,
              LinkCellRenderer,
              MapThumbnailCellRenderer,
            },
            rowHeight: 80,
            suppressClickEdit: true,
            editType: 'fullRow',
            enableBrowserTooltips: false,
            tooltipShowDelay: 0,
            tooltipMouseTrack: true,
          }}
          initQueryParams={new PagedQueryParams()}
        />
      ) : (
        !hasAnyMaps && (
          <div className="map-list-card h-100">
            <div className="map-list-empty">
              <Icon
                name="map"
                variant="dark"
                size="8x"
                className="mb-3"
                disabled={false}
                showPointer={false}
              />
              <Text className="mb-3" as="h5">
                Whoops looks like you don't have any Maps!
              </Text>
              {isReadOnly() === false && isUser() === false && (
                <>
                  <Text className="mb-4" as="h5">
                    Would you like to create one?
                  </Text>
                  <Link to="/maps/create">
                    <Button className="create-map" variant="primary">
                      Create Map
                      <i className="sonarIcon sonarIcon-add fs-sm" />
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </div>
        )
      )}
    </>
  );
}
